module.exports = __webpack_public_path__ + "ae18cb42cc7e91f0c836d0765d96608f.svg";